module.exports = __webpack_public_path__ + "img/brunch-texto-forma.8c921205.png";